import { render, staticRenderFns } from "./LetsGoTask.vue?vue&type=template&id=4bf855cf&scoped=true&"
import script from "./LetsGoTask.vue?vue&type=script&lang=js&"
export * from "./LetsGoTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf855cf",
  null
  
)

export default component.exports